/**
 * 물리와 루프의 전역 상수.
 *
 * 이 값들은 코드 곳곳에 흩어지면 튜닝이 불가능해진다.
 * 이전 Unity MVP는 0.3f, 0.25f 같은 매직넘버가 상태 전이에 박혀 있어
 * 조작감을 조절할 수 없었다. 같은 실수를 반복하지 않는다.
 */

/** 물리 고정 간격. 결정론의 전제이므로 런타임에 바꾸지 않는다. */
export const FIXED_DT = 1 / 60;

/**
 * 한 프레임에 소비할 실시간 delta의 상한.
 * 탭이 백그라운드에 있다 돌아오면 delta가 수 초로 튀는데,
 * 그대로 accumulator에 넣으면 물리가 수백 스텝 폭주한다.
 */
export const MAX_FRAME_DELTA = 0.25;

export const GRAVITY = { x: 0, y: -9.81, z: 0 } as const;
